var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaHaciaAbajoParaNavegar1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 10.9902C6.74905 10.9902 6.49818 10.8944 6.30688 10.7032L0.287198 4.68341C-0.0957326 4.30048 -0.0957326 3.67962 0.287198 3.29685C0.669973 2.91407 1.29071 2.91407 1.67367 3.29685L6.99996 8.62345L12.3263 3.29703C12.7092 2.91426 13.3299 2.91426 13.7126 3.29703C14.0957 3.67981 14.0957 4.30066 13.7126 4.6836L7.69304 10.7033C7.50165 10.8946 7.25078 10.9902 6.99996 10.9902Z",
    fill: "#2D3035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaHaciaAbajoParaNavegar1);
export default __webpack_public_path__ + "static/media/flecha-hacia-abajo-para-navegar 1.84d137a8a6660abc169a1d0ac8ef9041.svg";
export { ForwardRef as ReactComponent };